<template>
<div class="chapter">
<div class="inner_page">
<p class="ht"><a id="pI"></a>GALLIPOLI</p>
<p class="ftxt">R<span class="fsc">OBIN</span> P<span class="fsc">RIOR</span> is visiting professorial fellow, University of Adelaide, and visiting fellow, University of New South Wales, Australian Defence Force Academy. He is coauthor with Trevor Wilson of <i>Passchendale: The Untold Story</i> (1996) and <i>The Somme</i> (2005), both published by Yale.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// half_title.vue?b4d9a7e6